
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import { UserResource } from '@/api/requests/types';
import VueAvatar from 'vue-avatar';
import { TenantResource } from '@/api/requests/tenant/types';

@Component({
    components: { PlusIcon, VueAvatar },
})
export default class TenantPopup extends Vue {
    @State user!: UserResource;

    getUsername(tenant: TenantResource){
        return tenant.slug.replace(/^\w/, (c) => c.toUpperCase());
    }
}
